<youtube-player
  [class.student-life-size]="studentLifeCardSize"
  [videoId]="videoId"
  suggestedQuality="highres"
  (stateChange)="videoStateChanged($event)"
  #player
  style="width: auto; height: auto"
>
</youtube-player>
